import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { Button, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimeField } from "@mui/x-date-pickers/TimeField";

import { URL, colors } from "../../../utils/constant";
import DropDown from "../../../component/shared/DropDown";

import { joiResolver } from "@hookform/resolvers/joi";
import UseBloodSugarRecord from "../../../data/talons/BloodSugarRecord/UseBloodSugarRecord";

import dayjs from "dayjs";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  getBloodSugarUpdate,
  getFlage,
  getHypoUpdate,
  getPageId,
} from "../../../data/selector/component.selector";
import { get, size } from "lodash";
import {
  getLanguage,
  getLanguageNumber,
} from "../../../data/selector/language.selector";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../data/talons/auth/useAuth";
import { getUserToken } from "../../../data/selector/appState.selector";
import {
  DatePicker,
  TimePicker,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { getSelectedDate } from "../../../data/selector/visits.selector";
import {
  getBSSubmitFlag,
  getBloodSugarFlag,
  getListFlag,
} from "../../../data/selector/bloodSugarRecord.selector";
import {
  setBloodSugarComponent,
  setFlage,
  setHypoComponent,
} from "../../../data/reducer/component.reducer";
import {
  setBSSubmitFlag,
  setBloodSugarFlag,
  setSelectedList,
  setListFlag,
} from "../../../data/reducer/bloodSugarRecord.reducer";
import { setSelectedLanguage } from "../../../data/reducer/language.reducer";
import { English } from "../../../Languages/en";
import { Spanish } from "../../../Languages/sp";
import Dialogue from "../../../component/shared/Dialogue";
import UseBloodSugarRecordList from "../../../data/talons/BloodSugarRecord/UseBloodSugarRecordList";
import useHypoglycemiaList from "../../../data/talons/Hypoglycemia/useHypoglycemiaList";
import { RHFSelect } from "../../../component/shared/RHFSelect";

// Define Joi schema for your form fields

const BloodSugarRecord = ({ selectedVisitId }) => {
  const navigate = useNavigate();

  const { fetchBSRecordsList } = UseBloodSugarRecordList();
  const { fetchRecordsList } = useHypoglycemiaList();
  // const { autoLogout } = useAuth();
  // const { inactivityTimeout, handleMouseMove, isActive } = autoLogout();
  const { submitBSData, selectedListData, schema, updateBSData } =
    UseBloodSugarRecord();
  const [timeDropdownValue, setTimeDropdownValue] = useState(
    size(selectedListData?.BS_TIME) > 0 ? selectedListData?.BS_TIME : null
  );
  const [PageID, setPageID] = useState(0);
  // const [bloodSugar, setBloodSugar] = useState(
  //   size(selectedListData?.BS_SUGAR) > 0 ? selectedListData?.BS_SUGAR : ""
  // );
  const [mealCodeDropdownValue, setMealCodeDropdownValue] = useState(
    size(selectedListData?.MEAL) > 0 ? selectedListData?.MEAL : null
  );
  const [insulinTypeDropdownValue, setInsulinTypeDropdownValue] = useState(
    size(selectedListData?.BS_INTYPE) > 0 ? selectedListData?.BS_INTYPE : null
  );
  const [insulinType2DropdownValue, setInsulinType2DropdownValue] = useState(
    size(selectedListData?.BS_ITYPE) > 0 ? selectedListData?.BS_ITYPE : null
  );
  const [pumpInsulinTypeDropdownValue, setPumpInsulinTypeDropdownValue] =
    useState(
      size(selectedListData?.BS_PTYPE) > 0 ? selectedListData?.BS_PTYPE : null
    );
  const [mealTime, setMealTime] = useState(
    size(selectedListData?.BS_MTIME) > 0
      ? dayjs("01-01-2020 " + selectedListData?.BS_MTIME)
      : null
  );
  const flag = useSelector(getBloodSugarFlag);

  const Language = useSelector(getLanguage);
  const number = useSelector(getLanguageNumber);
  const [Errors, setErrors] = useState({
    time: "",
    meal: "",
    insulin: "",
    insulin2: "",
    pumpInsulin: "",
    MealTime: "",
    // bloodSugar: "",
  });
  const [forceUpdate, setForceUpdate] = useState(false);

  const initialState = () => {
    setMealCodeDropdownValue(null);
    setInsulinTypeDropdownValue(null);
    setInsulinType2DropdownValue(null);
    setPumpInsulinTypeDropdownValue(null);
    setMealTime(null);
    setTimeDropdownValue(null);
    // Add this line after setting dropdown values to null
    setForceUpdate((prevState) => !prevState);
  };
  const pageStatusObj = useSelector(getPageId);
  const getDate = useSelector(getSelectedDate);
  const formattedDate = dayjs(getDate);
  const dispatch = useDispatch();
  const [Date, setDate] = useState(formattedDate);
  const [Open, setOpen] = useState(false);
  const [Alert, setAlert] = useState("");
  const getListflag = useSelector(getListFlag);

  useEffect(() => {
    setDate(formattedDate);
  }, [getDate]);

  useEffect(() => {
    // console.log(dropdownValue, "vkvkvkv");
    if (!number) {
      // console.log("noneWnglish");
      dispatch(setSelectedLanguage(English));
    } else if (number == 1) {
      // console.log("english");
      dispatch(setSelectedLanguage(English));
    } else if (number == 2) {
      // console.log("spanish");
      dispatch(setSelectedLanguage(Spanish));
    }
    // dispatch(setSelectedLanguage(Spanish));
    // console.log("nnnn");
  }, [number]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    control,
    reset,
  } = useForm({
    resolver: joiResolver(schema),
    defaultValues: {
      Blood_sugar_value: get(selectedListData, "BS_SUGAR", ""),
      Bolus_Insulin: get(selectedListData, "BS_INSULIN", ""),
      Basal_Insulin: get(selectedListData, "BS_BINSULIN", ""),
      Pump_Insulin_Units: get(selectedListData, "BS_UNITS", ""),
    },
    // Apply Joi resolver to the form
  });
  const bloodSugarSelector = useSelector(getBloodSugarUpdate);
  const selector = useSelector(getHypoUpdate);
  // console.log(PageID, "pageid");
  const onSubmit = useCallback(async (data) => {
    let hasError = false;
    let newErrors = { ...Errors }; // Copy existing errors
    if (!mealTime || !dayjs(mealTime).isValid()) {
      newErrors.MealTime = Language?.error.BloodSugarRecord.MealTime;
      hasError = true;
    }
    // // Check each dropdown and set errors if not selected

    if (hasError) {
      // If any error is found, update the Errors state and return
      setErrors(newErrors);
      return;
    }

    // If no errors, proceed with form submission
    setErrors({}); // Clear any previous errors
    const {
      Basal_Insulin,
      Blood_sugar_value,
      Bolus_Insulin,
      Pump_Insulin_Units,
    } = data;

    const formattedMealTime = dayjs(mealTime).format("h:mm A");
    const submitData = {
      Basal_Insulin,
      Blood_sugar_value,
      Bolus_Insulin,
      Pump_Insulin_Units,
      PageID,
      formattedMealTime,
      timeDropdownValue,
      mealCodeDropdownValue,
      insulinTypeDropdownValue,
      insulinType2DropdownValue,
      pumpInsulinTypeDropdownValue,
    };
    if (Blood_sugar_value <= 54) {
      dispatch(setListFlag(false));

      const res = await (flag
        ? updateBSData(submitData)
        : submitBSData(submitData));
      const row = {
        ItemList: [
          {
            ItemId: "HYPO_DATE",
            ItemValue: Date,
          },
          {
            ItemId: "HYPO_TIME",
            ItemValue: formattedMealTime,
          },
          {
            ItemId: "BS_VALUE",
            ItemValue: Blood_sugar_value,
          },
        ],
      };

      dispatch(setSelectedList(row));
      setOpen(true);
      setAlert(Language.AlertMsg.navigateToHypoglycemia);
      // dispatch(setHypoComponent(true));

      // navigate(URL.form);
    } else {
      dispatch(setListFlag(true));

      const res = await (flag
        ? updateBSData(submitData)
        : submitBSData(submitData));

      // console.log(submitData, "submittt");
      if (res === true) {
        if (selector) {
          fetchRecordsList(PageID);
        } else {
          fetchBSRecordsList(PageID);
        }
        reset();
        initialState();
        dispatch(setSelectedList(null));
        dispatch(setBloodSugarFlag(false));
        dispatch(setBSSubmitFlag());
      }
    }

    // console.log("response", res);
  });

  useEffect(() => {
    setPageID(pageStatusObj?.pageData);
    let RecordNO = pageStatusObj?.pageData?.PageName?.split("");
    if (RecordNO) {
      RecordNO = RecordNO[RecordNO?.length - 1];
    }
    if (bloodSugarSelector?.recordNo == RecordNO) {
      setPageID(pageStatusObj?.pageData?.PageId);
    }
  }, [pageStatusObj, bloodSugarSelector, setPageID]);

  const selectedMeal =
    size(selectedListData?.MEAL) === 0
      ? ""
      : English.BloodSugarRecords.Meal_Code_Dropdown.find((item) => {
          return item.name === selectedListData?.MEAL;
        }) || "";
  const selectedTimeDropdown =
    size(selectedListData?.BS_TIME) === 0
      ? ""
      : English.BloodSugarRecords.Time_Dropdown.find((item) => {
          return item.name === selectedListData?.BS_TIME;
        }) || "";

  const selectedInsulineType =
    size(selectedListData?.BS_INTYPE) === 0
      ? ""
      : English.BloodSugarRecords.Insulin_Type_Dropdown.find((item) => {
          return item.name === selectedListData?.BS_INTYPE;
        }) || "";

  const selectedInsulineType2 =
    size(selectedListData?.BS_ITYPE) === 0
      ? ""
      : English.BloodSugarRecords.Insulin_Type_Dropdown.find((item) => {
          return item.name === selectedListData?.BS_ITYPE;
        }) || "";

  const selectedPumpInsulineType =
    size(selectedListData?.BS_PTYPE) === 0
      ? ""
      : English.BloodSugarRecords.Pump_Insulin_Type_Dropdown.find((item) => {
          return item.name === selectedListData?.BS_PTYPE;
        }) || "";

  return (
    <Grid width={"100vw"} sx={{ backgroundColor: "whitesmoke" }}>
      <ToastContainer />
      <Dialogue
        open={Open}
        setOpen={setOpen}
        Alert={Alert}
        navigate={setHypoComponent(true)}
      />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="d-flex"
        style={{
          backgroundColor: "whitesmoke",
          justifyContent: "center",
          // height: "110vh",
        }}
      >
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          sx={{
            px: 3,
            mt: 8.5,
            ml: "410px",
          }}
        >
          <Grid
            sx={{
              px: 3,
              pt: 3,
              width: "70%",
              backgroundColor: colors.white,
            }}
          >
            <Typography className="fw-bold text-center">
              {Language.BloodSugarRecords.newRecord}
            </Typography>
            <Grid container gap={2}>
              <Grid xs={5.6} alignItems={"center"} mt={5}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={Language.HypoglycemiaTitles.Date}
                    sx={{ width: "100%" }}
                    name="date"
                    value={Date}
                    format="DD/MM/YYYY"
                    onChange={(newValue) => {
                      setDate(newValue);
                      setErrors({ ...errors, date: "" });
                    }}
                    disabled
                  />
                </LocalizationProvider>
                {errors.date && (
                  <Typography variant="body2" color="error">
                    {errors.date}
                  </Typography>
                )}
              </Grid>
              <Grid xs={6} alignItems={"center"} mt={5}>
                <RHFSelect
                  // native
                  name="time_Dropdown_Value"
                  label={Language.BloodSugarRecords.Time}
                  // InputLabelProps={{ shrink: true }}
                  method={control}
                  defaultValue={selectedTimeDropdown?.id}
                >
                  {Language.BloodSugarRecords.Time_Dropdown?.map((item) => {
                    return (
                      <MenuItem
                        key={item?.id}
                        label={item?.name}
                        value={item?.id}
                        onClick={() => setTimeDropdownValue(item?.id)}
                      >
                        {item?.name}
                      </MenuItem>
                    );
                  })}
                </RHFSelect>
              </Grid>
            </Grid>
            <Grid container gap={2} className="mt-3">
              <Grid xs={5.6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label={Language.BloodSugarRecords.Meal_Time}
                    viewRenderers={{
                      hours: renderTimeViewClock,
                      minutes: renderTimeViewClock,
                      seconds: renderTimeViewClock,
                    }}
                    value={mealTime}
                    onChange={(value) => {
                      setErrors({ ...errors, MealTime: "" });
                      setMealTime(value);
                    }}
                    slotProps={{ textField: { fullWidth: true } }}
                    // fullWidth
                  />
                </LocalizationProvider>
                {Errors.MealTime && (
                  <Typography variant="body2" color="error">
                    {Errors.MealTime}
                  </Typography>
                )}
              </Grid>

              {/* {console.log(mealTime, "mealTimemealTimemealTimev")} */}
              <Grid xs={6} direction={"row"}>
                {/* {console.log(selectedMeal?.id, "selectedListData?.MEAL")} */}
                <RHFSelect
                  // native
                  name="Meal_Code_Dropdown"
                  label={Language.BloodSugarRecords.Meal_Code}
                  // InputLabelProps={{ shrink: true }}
                  method={control}
                  defaultValue={selectedMeal?.id}
                >
                  {Language.BloodSugarRecords.Meal_Code_Dropdown?.map(
                    (item) => {
                      return (
                        <MenuItem
                          key={item?.id}
                          label={item?.name}
                          value={item?.id}
                          onClick={() => setMealCodeDropdownValue(item?.id)}
                        >
                          {item?.name}
                        </MenuItem>
                      );
                    }
                  )}
                </RHFSelect>
              </Grid>
            </Grid>

            <Grid container className="mt-3">
              <Grid xs={12}>
                <TextField
                  key={forceUpdate}
                  defaultValue={selectedListData?.BS_SUGAR || ""}
                  name="Blood_sugar_value"
                  id="Blood_sugar_value"
                  label={Language.BloodSugarRecords.Blood_sugar_value}
                  fullWidth
                  {...register("Blood_sugar_value")}
                  error={!!errors.Blood_sugar_value}
                  helperText={errors.Blood_sugar_value?.message}
                />
              </Grid>
            </Grid>

            <Grid container className="mt-3" gap={2}>
              <Grid xs={5.6}>
                <TextField
                  name="Bolus_Insulin"
                  id="Bolus_Insulin"
                  fullWidth
                  label={Language.BloodSugarRecords.Bolus_Insulin}
                  {...register("Bolus_Insulin")}
                  error={!!errors.Bolus_Insulin}
                  helperText={errors.Bolus_Insulin?.message}
                />
              </Grid>
              <Grid xs={6}>
                <RHFSelect
                  // native
                  name="Insulin_Type_Dropdown"
                  label={Language.BloodSugarRecords.Insulin_Type}
                  // InputLabelProps={{ shrink: true }}
                  method={control}
                  defaultValue={selectedInsulineType?.id}
                >
                  {Language.BloodSugarRecords.Insulin_Type_Dropdown?.map(
                    (item) => {
                      return (
                        <MenuItem
                          key={item?.id}
                          label={item?.name}
                          value={item?.id}
                          onClick={() => setInsulinTypeDropdownValue(item?.id)}
                        >
                          {item?.name}
                        </MenuItem>
                      );
                    }
                  )}
                </RHFSelect>
              </Grid>
            </Grid>

            <Grid container className="mt-3" gap={2}>
              <Grid xs={5.6}>
                <TextField
                  name="Basal_Insulin"
                  id="Basal_Insulin"
                  label={Language.BloodSugarRecords.Basal_Insulin}
                  fullWidth
                  {...register("Basal_Insulin")}
                  error={!!errors.Basal_Insulin}
                  helperText={errors.Basal_Insulin?.message}
                />
              </Grid>
              <Grid xs={6} direction={"row"}>
                <RHFSelect
                  // native
                  name="Insulin_Type2_Dropdown"
                  label={Language.BloodSugarRecords.Insulin_Type}
                  // InputLabelProps={{ shrink: true }}
                  method={control}
                  defaultValue={selectedInsulineType2?.id}
                >
                  {Language.BloodSugarRecords.Insulin_Type_Dropdown?.map(
                    (item) => {
                      return (
                        <MenuItem
                          key={item?.id}
                          label={item?.name}
                          value={item?.id}
                          onClick={() => setInsulinType2DropdownValue(item?.id)}
                        >
                          {item?.name}
                        </MenuItem>
                      );
                    }
                  )}
                </RHFSelect>
              </Grid>
            </Grid>

            <Grid container className="mt-3" gap={2}>
              <Grid xs={5.6} direction={"row"}>
                <TextField
                  name="Pump_Insulin_Units"
                  id="Pump_Insulin_Units"
                  label={Language.BloodSugarRecords.Pump_Insulin_Units}
                  fullWidth
                  {...register("Pump_Insulin_Units")}
                  error={!!errors.Pump_Insulin_Units}
                  helperText={errors.Pump_Insulin_Units?.message}
                />
              </Grid>
              <Grid xs={6}>
                <RHFSelect
                  // native
                  name="PumpInsulin_Type_Dropdown"
                  label={Language.BloodSugarRecords.Pump_Insulin_Type}
                  // InputLabelProps={{ shrink: true }}
                  method={control}
                  defaultValue={selectedPumpInsulineType?.id}
                >
                  {Language.BloodSugarRecords.Pump_Insulin_Type_Dropdown?.map(
                    (item) => {
                      return (
                        <MenuItem
                          // key={forceUpdate}
                          key={item?.id}
                          label={item?.name}
                          value={item?.id}
                          onClick={() =>
                            setPumpInsulinTypeDropdownValue(item?.id)
                          }
                        >
                          {item?.name}
                        </MenuItem>
                      );
                    }
                  )}
                </RHFSelect>
              </Grid>
            </Grid>
            <Grid
              mt={3}
              mb={1.5}
              direction={"row"}
              gap={2}
              justifyContent={"end"}
              container
            >
              <Grid>
                <Button
                  type="submit"
                  variant="contained"
                  onClick={handleSubmit(onSubmit)}
                  sx={{
                    width: "7rem",
                    mt: 1,
                    mb: 2,
                    backgroundColor: colors.blue,
                    "&:hover": {
                      backgroundColor: colors.blue,
                    },
                  }}
                >
                  {Language.ButtonText.Submit}
                </Button>
              </Grid>
              <Grid>
                <Button
                  // type="submit"
                  type="button"
                  variant="contained"
                  onClick={() => {
                    navigate(URL.savedRecords);
                  }}
                  sx={{
                    width: "7rem",
                    mt: 1,
                    mb: 2,
                    backgroundColor: colors.blue,
                    "&:hover": {
                      backgroundColor: colors.blue,
                    },
                  }}
                >
                  {Language.ButtonText.Cancel}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};

export default BloodSugarRecord;
